import Accordion, { IAccordionPanel } from "app/components/basic/Accordion";
import { ILinkGroup } from "app/utils/interfaces";
import { generateMenuList, generatePanelTitleElement } from "./InternalMenu.Functions";
import "./InternalMenu.scss";

interface IProps {
	currentActiveLink: string;
	linkGroups: ILinkGroup[];
	accordionTitle: string;
	showInTablet?: boolean;
}

const generatePanel = (props: IProps): IAccordionPanel[] => [
	{
		title: props.accordionTitle,
		titleAsElement: generatePanelTitleElement("accordion", props.accordionTitle),
		content: <div>{generateMenuList(props.linkGroups, props.currentActiveLink, "accordion")}</div>,
	},
];

const InternalMenuAccordion = (props: IProps): JSX.Element => {
	return (
		<div className={`internal-menu--accordion ${props.showInTablet ? "internal-menu--accordion--tablet" : ""}`}>
			<Accordion id="internal-menu--accordion" panels={generatePanel(props)} />
		</div>
	);
};

export default InternalMenuAccordion;
